(function () {
  'use strict';
  
  var globalScope = /** @type {any} */ (window);
  if (globalScope.__pssScriptInit) return;
  globalScope.__pssScriptInit = true;

  function initReviewCarousels(root) {
    root.querySelectorAll('[data-pss-reviews]').forEach(function (wrapper) {
      if (wrapper.dataset.pssReviewsInit === 'true') return;
      wrapper.dataset.pssReviewsInit = 'true';

      var track = wrapper.querySelector('.pss__reviews-track');
      var prevBtn = wrapper.querySelector('[data-pss-reviews-prev]');
      var nextBtn = wrapper.querySelector('[data-pss-reviews-next]');
      if (!track) return;

      function scrollByCard(direction) {
        var card = track.querySelector('.pss__review-card');
        var amount = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= max;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    });
  }

  function initAll(context) {
    (context || document).querySelectorAll('[data-section-type="pharmacist-story-slider"]').forEach(initReviewCarousels);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    function showLoader(btn) {
      btn.classList.add('loading');
      btn.setAttribute('aria-disabled', 'true');
    }
    function hideLoader(btn) {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-disabled');
    }
    // ================= START: pss__product-actions Add to Cart (standalone AJAX) =============== //
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.pss__product-actions .pss__btn');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('loading')) return;

      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      const sellingPlan = btn.dataset.sellingPlan;

      showLoader(btn);

      const item = sellingPlan
        ? { id: variantId, quantity: 1, selling_plan: sellingPlan }
        : { id: variantId, quantity: 1 };

      const sectionIds = Array.prototype.map.call(
        document.querySelectorAll('cart-items-component'),
        function (el) { return el.dataset.sectionId; }
      ).filter(Boolean);

      const cartAddUrl = (typeof Theme !== 'undefined' && Theme.routes.cart_add_url) || '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [item],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status || response.errors) {
            console.error(response.description || response.message || response.errors);
            return;
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: response,
                sourceId: 'pss-product-actions-btn',
                data: {
                  source: 'pss-product-actions-btn',
                  sections: response.sections,
                },
              },
            })
          );
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          hideLoader(btn);
        });
    });
    // ================= END: pss__product-actions Add to Cart (standalone AJAX) =============== //
    // ================= START: pss__final-actions text-link Add to Cart (standalone AJAX) =============== //
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.pss__final-actions .pss__text-link');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('loading')) return;

      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      const sellingPlan = btn.dataset.sellingPlan;

      showLoader(btn);

      const item = sellingPlan
        ? { id: variantId, quantity: 1, selling_plan: sellingPlan }
        : { id: variantId, quantity: 1 };

      const sectionIds = Array.prototype.map.call(
        document.querySelectorAll('cart-items-component'),
        function (el) { return el.dataset.sectionId; }
      ).filter(Boolean);

      const cartAddUrl = (typeof Theme !== 'undefined' && Theme.routes.cart_add_url) || '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [item],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status || response.errors) {
            console.error(response.description || response.message || response.errors);
            return;
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: response,
                sourceId: 'pss-final-actions-text-link',
                data: {
                  source: 'pss-final-actions-text-link',
                  sections: response.sections,
                },
              },
            })
          );
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          hideLoader(btn);
        });
    });
    // ================= END: pss__final-actions text-link Add to Cart (standalone AJAX) =============== //
    // ================= START: pss__final-actions .pss__btn Add to Cart (proxies pss__product-actions .pss__btn) =============== //
    document.addEventListener('click', function(e) {
      const finalBtn = e.target.closest('.pss__final-actions .pss__btn');
      if (!finalBtn) return;
      e.preventDefault();
      if (finalBtn.classList.contains('loading')) return;
      showLoader(finalBtn);
      const productBtn = document.querySelector('.pss__product-actions .pss__btn');
      if (productBtn) {
        productBtn.click();
      }
      setTimeout(() => hideLoader(finalBtn), 1000);
    });
    // ================= END: pss__final-actions .pss__btn Add to Cart =============== //
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-section-type="pharmacist-story-slider"]');
      if (section) initReviewCarousels(section);
    });
  }

   const swiper = new Swiper(".testimonialSwiper", {
      speed: 800,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".testimonial-pagination",
        clickable: true,
      },
      breakpoints: {
          0: {
            slidesPerView: 1.239,
            spaceBetween: 16,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 16,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
          1025: {
            slidesPerView: 2.15,
            spaceBetween: 20,
            slidesOffsetBefore: 30,
            slidesOffsetAfter: 30,
          },
      }
  });

  
})();
